var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtueIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 14.6005,
    x2: 0.435038,
    y1: 19.9179,
    y2: 9.20348
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffee10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb900"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.6 22.5-1.9-3.2-3.6-.8.35-3.7-2.45-2.8 2.45-2.8-.35-3.7 3.6-.8 1.9-3.2 3.4 1.45 3.4-1.45 1.9 3.2 3.6.8-.35 3.7 2.45 2.8-2.45 2.8.35 3.7-3.6.8-1.9 3.2-3.4-1.45zm2.35-6.95 5.65-5.65-1.4-1.45-4.25 4.25-2.15-2.1-1.4 1.4z",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtueIconCheck);
export default __webpack_public_path__ + "static/media/ftue_icon_check.3918acf286d2ca492d4dd72b179c3a3b.svg";
export { ForwardRef as ReactComponent };